import defaultSettings from '@/settings'
const title = defaultSettings.title || '两山平台'
export default function getPageTitle(pageTitle){
	if(pageTitle){
		return `${pageTitle}-${title}`
	}
	return `${title}`
}